// Module
var code = `<!-- HERO — v2 RATIFIED (copy of record 2026-08-13) -->
<section aria-labelledby="hero-headline">
    <p class="hero-eyebrow">SIX YEARS IN FORTUNE 100 PRODUCTION · OPEN SOURCE</p>
    <h1 class="hero-headline">The Behavior-First<br>Frontend Framework</h1>
    <p class="hero-sub-1">SpyneJS elevates Behavior to the level of Views, <br>so structure is defined in the code</p>
    <p class="hero-spec-line">The Codebase is the Spec</p>

    <div class="cta-buttons">
        <a data-channel="ROUTE"
           data-event-prevent-default="true"
           data-page-id="configure"
           href="/configure"
           class="landing-btn landing-btn-primary">Start with an Application Shell</a>
        <a data-channel="ROUTE"
           data-event-prevent-default="true"
           data-page-id="docs"
           data-stage="examples"
           data-text="Docs"
           href="/docs/examples"
           class="landing-btn landing-btn-outline">Learn from Examples</a>
        <div class="cli-snippet">
            <div class="code-container">
                <code>npx spyne-cli create-app</code>
                <button type="button" aria-label="Copy command">⧉</button>
            </div>
        </div>
    </div>
</section>
`;
// Exports
module.exports = code;